import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Globals } from '../../globals';
import { TokenServiceService } from '../service/token-service.service';
import { PatientService } from '../../modules/patient/patient.service';
import { MessagingService } from '../../services/messaging.service';

@Component({
  selector: 'app-token-handler',
  templateUrl: './token-handler.component.html',
  styleUrls: ['./token-handler.component.css']
})
export class TokenHandlerComponent implements OnInit {

  isLoading: boolean = true;
  hasError: boolean = false;
  redirectUrl: string = '/';
  messageSubscription: any;
  token: string;
  redirectTimeout: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private messagingService: MessagingService,
    private tokenService: TokenServiceService,
    private patientService: PatientService,
    public globals: Globals,
  ) { }

  ngOnInit() {

    if (this.route.queryParams) {
      this.route.queryParams.subscribe(parameters => {
        if (parameters && parameters.token) {
          this.token = parameters.token;
          this.parseToken();
        } else {
          this.router.navigate(['/']);
        }
      });
    }
  }

  parseToken() {
    this.isLoading = true;
    this.tokenService.decodeToken(this.token)
      .subscribe((decodedToken: any) => {
        if (decodedToken) {
          let promises = [
            this.checkForTDO12User(decodedToken)
          ];
          Promise.all(promises).then((results: any[]) => {
            if (results[0]) {
              this.globals.currentPatientId = results[0]; //tdox PatientID
              this.messagingService.recursiveBroadCastMessage("MessagingConstants.PATIENT_CHANGED", { PatientId: results[0] });
              //this.messagingService.recursiveBroadCastMessage("MessagingConstants.PATIENT_CHANGED", { PatientID: results[0] });
            }
            this.isLoading = false;
            this.router.navigate([decodedToken.url])
          }, err => {
            this.isLoading = false;
            this.hasError = true;
            this.startRedirectTime();
            console.log(err);
          });
        } else {
          this.isLoading = false;
          this.hasError = true;
          this.startRedirectTime();
          console.log('error no decoded token');
        }
      });
  }

  checkForTDO12User(decodedToken) {
    let promise = new Promise((resolve, reject) => {
      if (typeof decodedToken.patientid != "undefined") {
        this.globals.tdo12patientNO = `${decodedToken.patientid}`;
        this.patientService.getTDO12Patient(decodedToken.patientid)
          .subscribe(response => {

            // now you have the guid.... api/Patient/GUID

            resolve(response);
          }, err => {
            reject(err);
          });
      } else {
        resolve(false);
      }
    });
    return promise;
  }

  startRedirectTime() {
    if (this.redirectTimeout) {
      clearTimeout(this.redirectTimeout);
    }

    this.redirectTimeout = setTimeout(_ => {
      this.router.navigate(['/']);
    }, 5000);
  }

}
